export class BankDetailsModel{

    public AccountTitle:string;
    public TypeOfAccount:string;
    public NameOfBankUDF:string;
    constructor(){
        
    }
}